import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography, Modal } from "@mui/material";
import "assets/styles.css";

const DEFAULT_REDIRECT_URL =
  "https://forms.clickup.com/20418595/f/kf413-64092/0H07H8LXFZ91D0KUF3";

export default function RedirectModal({
  open,
  onClose,
  url = DEFAULT_REDIRECT_URL,
  ctaLabel = "Send Report",
  cancelLabel = "Cancel",
  ariaLabel = "Send Report",
}) {
  const handleRedirect = () => {
    window.open(url, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={ariaLabel}>
      <Box
        className="ExtractReportModal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "40vw",
          boxShadow: 24,
          textAlign: "center",
        }}
      >
        <Box className="ExtractReportButtons">
          <Button
            className="ExtractReportButton"
            onClick={handleRedirect}
            sx={{
              background: "var(--Custom-Primary-Blue, #2732D4)",
              "&:hover": { background: "#1F28B6" },
            }}
          >
            <Typography
              className="ExtractReportButtonTypo"
              sx={{ color: "#F6F6F6" }}
            >
              {ctaLabel}
            </Typography>
          </Button>

          <Button
            className="ExtractReportButton"
            onClick={onClose}
            sx={{
              background: "#FFF",
              border: "1px solid var(--Custom-Primary-Black, #000)",
              "&:hover": { background: "#F6F6F6" },
            }}
          >
            <Typography
              className="ExtractReportButtonTypo"
              sx={{ color: "var(--Custom-Primary-Black, #000)" }}
            >
              {cancelLabel}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

RedirectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string,
  ctaLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
};

RedirectModal.defaultProps = {
  url: DEFAULT_REDIRECT_URL,
  ctaLabel: "Send Report",
  cancelLabel: "Cancel",
  ariaLabel: "Send Report",
};
